import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterSideNav from 'ui-addon-react-router-dom/RouterSideNav';
import { AddOnsSideNavItem, BreezeIntelligenceSideNavItem, BundleSideNavItem, CommerceSideNavItem, ContentSideNavItem, CustomerPlatformSideNavItem, DataSideNavItem, FreeToolsSideNavItem, HubspotCreditsSideNavItem, MarketingPlusSideNavItem, MarketingSideNavItem, SalesSideNavItem, ServiceSideNavItem } from './SideNavItems';
import { useSideNavVisibility } from './hooks/useSideNavVisibility';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SideNavContainer = () => {
  const sideNavVisibility = useSideNavVisibility();
  const {
    canViewMarketingPlus,
    canViewBreezeIntelligence,
    canViewHubSpotCredits,
    canViewAddOns,
    canViewEnhancementsSection,
    canViewFreeTools,
    canViewBundlesPage
  } = sideNavVisibility;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(RouterSideNav, {
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.sidenav.sections.bundle"
      }),
      children: [/*#__PURE__*/_jsx(CustomerPlatformSideNavItem, {}), canViewFreeTools && /*#__PURE__*/_jsx(FreeToolsSideNavItem, {}), canViewBundlesPage && /*#__PURE__*/_jsx(BundleSideNavItem, {}), canViewMarketingPlus && /*#__PURE__*/_jsx(MarketingPlusSideNavItem, {})]
    }), /*#__PURE__*/_jsxs(RouterSideNav, {
      divider: true,
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.sidenav.sections.core`
      }),
      children: [/*#__PURE__*/_jsx(MarketingSideNavItem, {}), /*#__PURE__*/_jsx(SalesSideNavItem, {}), /*#__PURE__*/_jsx(ServiceSideNavItem, {}), /*#__PURE__*/_jsx(ContentSideNavItem, {}), /*#__PURE__*/_jsx(DataSideNavItem, {}), /*#__PURE__*/_jsx(CommerceSideNavItem, {})]
    }), canViewEnhancementsSection && /*#__PURE__*/_jsxs(RouterSideNav, {
      divider: true,
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.sidenav.sections.enhancements"
      }),
      children: [canViewBreezeIntelligence && /*#__PURE__*/_jsx(BreezeIntelligenceSideNavItem, {}), canViewHubSpotCredits && /*#__PURE__*/_jsx(HubspotCreditsSideNavItem, {}), canViewAddOns && /*#__PURE__*/_jsx(AddOnsSideNavItem, {})]
    })]
  });
};